import "./index.scss";
import { ButtonIcon } from "@wise-emotions/react-button";
import { GeneralSmallChevronDown } from "@wise-emotions/react-icons";
import { LiveInspectorData } from "types/types";
import { VideoProps } from "components/Video/types";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import Video from "components/Video";
import classNames from "classnames";

export interface HeroBannerProps {
  heroBlockContent: ReactNode;
  contentAlign: "left" | "right";
  backgroundMedia: ReactNode;
  bannerVideo?: VideoProps;
  internalWrapper: string;
  liveInspector: LiveInspectorData;
}

const HeroBanner = ({
  heroBlockContent,
  backgroundMedia,
  contentAlign,
  bannerVideo,
  internalWrapper,
  liveInspector,
}: HeroBannerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const videoColClasses = classNames("col-12", "col-md-5 col-lg-6", {
    "order-md-first": contentAlign === "right",
  });

  useEffect(() => {
    const callbackScroll = () => {
      const stickyElement = document.querySelector(".sticky-element");
      if (!stickyElement) return;

      const rect = ref.current!.getBoundingClientRect();
      const stickyBottom = stickyElement.getBoundingClientRect().bottom;
      const footerTop = document
        .querySelector(".footer-new__container")!
        .getBoundingClientRect().top;

      const isHeroBannerIntoView =
        rect.top < window.innerHeight && rect.bottom >= 0;

      const areFooterAndStickyTouching =
        Math.floor(footerTop) <= Math.floor(stickyBottom);

      if (stickyElement) {
        if (isHeroBannerIntoView || areFooterAndStickyTouching)
          stickyElement.classList.remove("sticky-element--show");
        else stickyElement.classList.add("sticky-element--show");
      }
    };

    document.addEventListener("scroll", callbackScroll);
    return () => {
      document.removeEventListener("scroll", callbackScroll);
    };
  }, []);

  return (
    <div className="hero-banner" {...liveInspector?.heroBanner}>
      <div className="hero-banner__background">{backgroundMedia}</div>
      <div className="hero-banner__container">
        <div className={`wrapContent wrapContentV2-xl-${internalWrapper}`}>
          <div className="row no-gutters">
            <div className="col-12 col-md-7 col-lg-6">
              <div
                ref={ref}
                data-testid="textWrapper"
                className="hero-banner__text"
              >
                {heroBlockContent}
              </div>
            </div>
            <div className={videoColClasses}>
              {bannerVideo && (
                <div data-testid="video" className="hero-banner__video">
                  <Video {...bannerVideo} openInModal />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="hero-banner__scroll-button">
        <ButtonIcon size="sm" theme="secondary" ariaLabel="scroll-down">
          <GeneralSmallChevronDown />
        </ButtonIcon>
      </div>
    </div>
  );
};

export default HeroBanner;
